import React, { useRef } from "react";
import PropTypes from "prop-types";

const APlusDialog = ({
  amplitudeKey,
  children,
  content,
  handleClose,
  href,
  isFreeTier,
  linkClasses,
  logoSrc,
  shouldRenderCloseBtn
}) => {
  const dialogRef = useRef();
  const defaultHandleClose = () => $(dialogRef.current).hide();

  const closeBtn = shouldRenderCloseBtn ? (
    <div className="a-plus-dialog__close-btn-container">
      <button
        aria-label="Close"
        className="btn btn-sm btn-borderless"
        onClick={handleClose || defaultHandleClose}
        type="button"
      >
        <span className="lc-icon lc-icon-sm lc-icon-close" aria-hidden="true" />
      </button>
    </div>
  ) : null;

  const renderedContent = () => {
    const className = "a-plus-dialog__content";

    if (content) {
      return (
        <p
          className={className}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      );
    }

    if (children) {
      return <div className={className}>{children}</div>;
    }

    return <p className={className} />;
  };

  return (
    <div className="a-plus-dialog a-plus-dialog--normal" ref={dialogRef}>
      {closeBtn}
      <div className="text-center a-plus-dialog__header">
        <img alt="LitCharts Logo" className="brand" src={logoSrc} />
      </div>
      <div className="text-center a-plus-dialog__body subtitle-1">
        {renderedContent()}
        <p>Plus so much more...</p>
        <a
          {...(amplitudeKey && { "data-amplitude": amplitudeKey })}
          className={`a-plus-dialog__subscribe btn btn-a-plus btn-lg btn--icon-left ${
            linkClasses || ""
          }`}
          href={href}
        >
          <i className="lc-icon lc-icon-sm lc-icon-lock-filled" />
          Get LitCharts A<sup>+</sup>
        </a>
      </div>
      {!isFreeTier && (
        <div className="text-left a-plus-dialog__footer subtitle-2">
          <div className="a-plus-dialog__sign-in">
            <span className="a-plus-dialog__sign-in--text">
              Already a LitCharts A<sup>+</sup> member?
            </span>
            <a href="/sign-in">Sign in!</a>
          </div>
        </div>
      )}
    </div>
  );
};

APlusDialog.defaultProps = {
  handleClose: () => {},
  shouldRenderCloseBtn: false
};

APlusDialog.propTypes = {
  amplitudeKey: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.string,
  handleClose: PropTypes.func,
  href: PropTypes.string.isRequired,
  isFreeTier: PropTypes.bool.isRequired,
  linkClasses: PropTypes.string,
  logoSrc: PropTypes.string,
  shouldRenderCloseBtn: PropTypes.bool
};

export default APlusDialog;
